angular.module("impactx.cscontract").directive("ixDeviationVisual", function(){    
    return {
        restrict: 'E',
        controller: 'DeviationVisualCtrl',
        controllerAs: 'deviationVisualCtrl',
        templateUrl: 'modules/cscontract/templates/deviationvisual.tmpl.html',
        scope: {
            baseValue: "=?",
            modelMin: "=",
            modelMax: "=",
            labelMin: "@",
            labelMax: "@",
            postFix: "@",
            clazz: "=?",
            valuePow: "=?",
            fixedDeviation: "=?",
            noValueLabel: "@",
            minDeviation: "=?"
        }
    };
});
